import { Directive, HostListener, Input } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalService } from '@zaoblako/web/core/services/global.service';
import { flatten } from 'flat';

@Directive({
  standalone: true,
  selector: '[crmConditionalRouterLink]'
})
export class ConditionalRouterLinkDirective {
  @Input() public routerLink: string | any[] | null = null;
  @Input() public queryParams = null;

  public constructor(private readonly router: Router, private readonly globalService: GlobalService) {}

  @HostListener('click', ['$event'])
  public onClick(event: MouseEvent): void {
    if (this.globalService.globalInfo.commonSettings?.cardOnNewTab && this.routerLink) {
      event.preventDefault();
      const url = this.router.serializeUrl(
        this.router.createUrlTree(typeof this.routerLink === 'string' ? [this.routerLink] : this.routerLink, {
          queryParams: this.queryParams ? flatten(this.queryParams) : this.queryParams
        })
      );
      window.open(url, '_blank');
    } else if (!this.globalService.globalInfo.commonSettings?.cardOnNewTab && this.routerLink) {
      this.router
        .navigate(typeof this.routerLink === 'string' ? [this.routerLink] : this.routerLink, {
          queryParams: this.queryParams ? flatten(this.queryParams) : this.queryParams
        })
        .catch(console.error);
    }
  }
}
